import { createRelatorioWorkbook } from '../relatorioExcelUtils';
import { fetchDadosExcel } from '@/services/relatorioTransacoesService';
import type { IAbateDetalheItem, ITransacaoAgrupada } from '@/types/relatorioTransacoes';

export interface IExcelReportResult {
  empty?: boolean;
  workbook?: ReturnType<typeof createRelatorioWorkbook>;
  fileName?: string;
}

interface IAbateExcelReportStrategyDeps {
  formatarDataBR: (value: string | null | undefined) => string;
}

export default class AbateExcelReportStrategy {
  private readonly formatarDataBR: IAbateExcelReportStrategyDeps['formatarDataBR'];

  constructor({ formatarDataBR }: IAbateExcelReportStrategyDeps) {
    this.formatarDataBR = formatarDataBR;
  }

  async build(item: ITransacaoAgrupada): Promise<IExcelReportResult> {
    if (item.id == null) {
      return { empty: true };
    }

    const { sintetico, analitico } = await fetchDadosExcel({ tipo: 'abate', id: String(item.id) });
    const resultAbate = sintetico as unknown as IAbateDetalheItem[];

    if (!resultAbate.length) {
      return { empty: true };
    }

    const resultAbateParsed = resultAbate.map((resultado) => ({
      Data: this.formatarDataBR(resultado.data_abate),
      GTA: resultado.nr_gta,
      UF: resultado.uf,
      lote: resultado.numero_lote,
      'Tipo Lote': resultado.tipo_lote,
      Especie: resultado.especie,
      Machos: resultado.lote_quantidade_machos,
      Fêmeas: resultado.lote_quantidade_femeas,
      'Peso Macho': resultado.peso_morto_macho,
      'Peso Fêmea': resultado.peso_morto_femea,
      Diagnóstico: resultado.diagnostico_nome,
      'Parte Afetada': resultado.parte_afetada_nome,
      'Qtd. Partes': resultado.quantidade_partes_afetadas,
      Destino: resultado.destino_condenacao,
    }));

    const fileName = `mapa-abate_${item.data}.xlsx`;
    const workbook = createRelatorioWorkbook(resultAbateParsed, analitico);

    return { workbook, fileName };
  }
}
